import $ from "jquery";
import auth, { startpoll, confirmDialog, get, post, scanbarcode, scaleMeasure, getGlobal, getString, getLocale, getProxyPercentWidth } from "../js/auth";
import { I18n } from "react-redux-i18n";
import { tmplparams } from "../js/order-list-util";
import { createTree } from "jquery.fancytree";
import EntityPageCode from "../components/EntityPageCode";
import admin, { resultHandler, getMenuItem, getBarcode } from "../js/admin";
import { capturePhotoWithData, crop, onPhotoDataSuccess } from "../js/camera-util";

const getResizedImageUrl = (url) => getProxyPercentWidth(30, url);
const LIQUID_MIN_DENSITY_KG_PER_L = 0.75;
const LIQUID_MAX_DENSITY_KG_PER_L = 1.35;

class BarcodesCode extends EntityPageCode {

	constructor() {
		super();
		super.publishFunctions(['saveBarcode', 'deleteBarcode', 'capturePhotoWithData', 'crop', 'phoneScanBarcode', 'scaleMeasure', 'setSelectedScale', 'calculate', 'syncBarcodes', 'synchronizeBarcodes', 'downloadBarcodes', 'uploadBarcodes', 'isInventoryDisposalItem']);
	}

	clearData = () => {

	}

	filter = {}

	ready = () => {

		if (auth.myStatus.restaurant_scales && auth.myStatus.restaurant_scales.length > 0 && (typeof localStorage.selectedScale === "undefined" || auth.myStatus.restaurant_scales.filter(s => s.name === localStorage.selectedScale).length === 0))
			localStorage.selectedScale = auth.myStatus.restaurant_scales[0].name;

		$('#main').replaceWith($('#barcodesMainTemplate').tmpl({
			...tmplparams()
		}));

		admin.getMenuItems(this.loadBarcodes);

		startpoll(this.serverSideMessageHandler);

		admin.initializeSelect2($('select.select2')).done(() => {
		});

		this.updateHooks();

	}

	isInventoryDisposalItem = (data) => {
		return data.defaultInventoryItem;
	}

	reload = () => {
		this.loadBarcodes();
	}

	loadBarcodes = () => {
		this.getBarcodes(data => {
			this.processBarcodes(data);
			this.syncBarcodes();
			this.barcodes.selectAll(false);
			$('#barcodes_select_all').prop('checked', false);
		});
	}

	serverSideMessageHandler(data) {
	}

	isBadEntry = (barcode) => {
		if (!barcode) {
			return true;
		}

		const hasRequiredFields = !!(barcode.image && barcode.name && barcode.quantity && barcode.tareWeight && barcode.grossWeight);
		const grossWeight = this.parseNumeric(barcode.grossWeight);
		const tareWeight = this.parseNumeric(barcode.tareWeight);
		const hasValidWeights = Number.isFinite(grossWeight) && Number.isFinite(tareWeight) && grossWeight >= 0 && tareWeight >= 0 && grossWeight > tareWeight;
		const densityValidation = this.getDensityValidation(barcode);
		const hasInvalidDensity = densityValidation.outOfBounds;

		return !hasRequiredFields || !hasValidWeights || hasInvalidDensity;
	}

	isBadBarcodeValue = (barcode) => {
		if (!barcode) {
			return true;
		}
		return !(barcode.id !== undefined && barcode.id !== null && ("" + barcode.id).trim() !== "");
	}

	filterNodes = node => {
		if (this.filter.barcode && ("" + node.data.id).indexOf(this.filter.barcode) === -1) {
			return false;
		}
		if (this.filter.central_database_status) {
			const status = node.data.status;
			switch (this.filter.central_database_status) {
				case "missing_in_central":
					if (status !== "local") return false;
					break;
				case "new_in_central":
					if (status !== "new") return false;
					break;
				case "exists_in_central":
					if (!["new", "equal", "notequal"].includes(status)) return false;
					break;
				case "synced_with_central":
					if (status !== "equal") return false;
					break;
				case "different_from_central":
					if (status !== "notequal") return false;
					break;
				default:
			}
		}
		if (this.filter.entry_quality_status === "bad_entries" && !this.isBadEntry(node.data)) {
			return false;
		}
		if (this.filter.entry_quality_status === "good_entries" && this.isBadEntry(node.data)) {
			return false;
		}
		if (this.filter.serving_type && ("" + node.data.quantity).indexOf(this.filter.serving_type) === -1) {
			return false;
		}
		if (this.filter.name && node.data.name.indexOf(this.filter.name) === -1) {
			return false;
		}
		if (this.filter.linked_product && (!node.data.linked_product || node.data.linked_product.indexOf(this.filter.linked_product) === -1)) {
			return false;
		}
		return true;
	}

	barcodes = null;
	barcodesData = null;
	localData = null;
	processBarcodes = (data) => {
		this.barcodesData = data;
		data.forEach((v, i) => {
			v.key = v.id;
			v.title = v.number;
			v.folder = false;
			v.extraClasses = v.extraClasses || "";
			if (!v.isActive)
				v.extraClasses = "itemDeactivated";
			if (v.shareable)
				v.extraClasses += " itemShareable";
			if (this.isBadEntry(v))
				v.extraClasses += " itemBadEntry";
			if (v.menuItem)
				v.linked_product = getLocale(getMenuItem(v.menuItem.id).name)
		});
		if (this.barcodes == null) {
			const instance = this;
			this.barcodes = createTree("table#barcodes", {
				checkbox: true,
				titlesTabbable: true, // Add all node titles to TAB chain
				source: data,
				zindex: 1000,
				icon: false,
				extensions: ["table", "gridnav", "persist", "filter"],
				filter: {
					counter: false,
					mode: "hide"
				},
				persist: {
					cookieDelimiter: "~",
					overrideSource: true,
					types: "active focus selected",
					cookiePrefix: 'prefix-barcodes-',
					store: 'local',
				},
				table: {
					checkboxColumnIdx: 0, // render the checkboxes into the this
					// column index (default: nodeColumnIdx)
					indentation: 16, // indent every node level by 16px
					nodeColumnIdx: 2
					// render node expander, icon, and title to this column (default:
					// #0)
				},
				gridnav: {
					autofocusInput: false, // Focus first embedded input if node
					// gets activated
					handleCursorKeys: true
					// Allow UP/DOWN in inputs to move to prev/next node
				},

				activate: function (event, data) {
					// A node was activated: display its title:
					var node = data.node;
					$('#edit').removeAttr('disabled');
					$('#delete').removeAttr('disabled');
					if (node.data.isActive) {
						$('#deactivate').removeAttr('disabled');
						$('#activate').prop('disabled', 'true');
					} else {
						$('#deactivate').prop('disabled', 'true');
						$('#activate').removeAttr('disabled');
					}

				},
				click: (event, data) => {
					if (this.clickTimestamp && this.selectedNodeKey === data.node.key && new Date().getTime() - this.clickTimestamp < 1000) {
						$('button#edit').click();
					};
					this.clickTimestamp = new Date().getTime();
					this.selectedNodeKey = data.node.key;
				},
				renderColumns: function (event, data) {
					var node = data.node, $tdList = $(node.tr).find(">td");
					node.expanded = true;
					const addBadMark = (cellIndex) => {
						const currentHtml = $tdList.eq(cellIndex).html() || "";
						$tdList.eq(cellIndex).html(currentHtml + '<span class="badge badge-danger" style="margin-left:0.25rem;color:lightgray">' + I18n.t("admin_local.bad") + '</span>');
					};
					const addBadMarkBeforeImage = (cellIndex) => {
						const $cell = $tdList.eq(cellIndex);
						const badgeHtml = '<span class="badge badge-danger" style="margin-right:0.25rem;color:lightgray">' + I18n.t("admin_local.bad") + '</span>';
						const $img = $cell.find('img').first();
						if ($img.length > 0) {
							$img.before(badgeHtml);
						} else {
							const currentHtml = $cell.html() || "";
							$cell.html(badgeHtml + currentHtml);
						}
					};
					const hasValue = (value) => value !== undefined && value !== null && ("" + value).trim() !== "";
					if (node.data.image) {
						const rawImageUrl = (node.data.status === "new" ? auth.globalserver : auth.server) + "/" + auth.war + "/tableService/" + (node.data.status === "new" ? 2 : localStorage.restaurantSelected) + "/getImage/" + node.data.image + "?a=" + (new Date().getTime() + Math.random()) + "&instance=" + (node.data.status === "new" ? "eatwithme" : localStorage.instance) /*+ node.data.image*/;
						var imageUrl = getResizedImageUrl(rawImageUrl);
						//var imageUrl = (node.data.status === "new" ? auth.globalserver : auth.server) + "/" + auth.war + "/adminService/restaurantService/isAlive?id=" + node.data.image;


						function onVisible(element, callback) {
							new IntersectionObserver((entries, observer) => {
								entries.forEach(entry => {
									if (entry.intersectionRatio > 0) {
										callback(element);
										observer.disconnect();
									}
								});
							}).observe(element);
							if (!callback) return new Promise(r => callback = r);
						}
						onVisible(node.tr, () => {
							setTimeout(() => {
								$tdList.eq(1).find('img').attr('src', imageUrl);
							}, Math.random() * 1000);
						})


						//$tdList.eq(1).find('img').attr('src', (node.data.status === "new" ? auth.globalserver : auth.server) + "/" + auth.war + "/adminService/" + (node.data.status === "new" ? 2 : localStorage.restaurantSelected) + "/getImage/" + node.data.image);
						/*if ($tdList.eq(1).find('img').attr('src') != imageUrl)
							$tdList.eq(1).find('img').attr('src', imageUrl);*/
					}
					$tdList.eq(2).text(node.data.id);
					$tdList.eq(3).text(node.data.name);
					$tdList.eq(4).text(node.data.quantity);
					$tdList.eq(5).text(node.data.grossWeight);
					$tdList.eq(6).text(node.data.tareWeight);
					switch (node.data.status) {
						case "new":
							$tdList.css("background", "yellow");
							$tdList.eq(2).html(I18n.t("admin_local.new_in_central_database") + "<br/>" + node.data.id);
							break;
						case "equal":
							$tdList.css("background", "lightgreen");
							break;
						case "notequal":
							$tdList.css("background", "red");
							$tdList.css("color", "white");
							const syncHint = node.data.syncHint;
							const preferredLabel = syncHint && syncHint.preferred === "local" ? I18n.t("admin_local.local_value") : I18n.t("admin_local.global_value");
							const hintHtml = syncHint
								? '<br/><small style="color:#f4f4f4">Hint: ' + preferredLabel + ' (' + I18n.t("admin_local.local_value") + ': ' + syncHint.localScore + ', ' + I18n.t("admin_local.global_value") + ': ' + syncHint.globalScore + ')</small>'
								: '';
							$tdList.eq(2).html(I18n.t("admin_local.exists_in_central_database") + "<br/>" + node.data.id + hintHtml);
							if (node.data.name != node.data.global.name) {
								$tdList.eq(3).html(node.data.name + "(" + I18n.t("admin_local.local_value") + ")<br/>" + node.data.global.name + "(" + I18n.t("admin_local.global_value") + ")");
							}
							if (node.data.quantity != node.data.global.quantity) {
								$tdList.eq(4).html(node.data.quantity + "(" + I18n.t("admin_local.local_value") + ")<br/>" + node.data.global.quantity + "(" + I18n.t("admin_local.global_value") + ")");
							}
							if (node.data.grossWeight != node.data.global.grossWeight) {
								$tdList.eq(5).html(node.data.grossWeight + "(" + I18n.t("admin_local.local_value") + ")<br/>" + node.data.global.grossWeight + "(" + I18n.t("admin_local.global_value") + ")");
							}
							if (node.data.tareWeight != node.data.global.tareWeight) {
								$tdList.eq(6).html(node.data.tareWeight + "(" + I18n.t("admin_local.local_value") + ")<br/>" + node.data.global.tareWeight + "(" + I18n.t("admin_local.global_value") + ")");
							}
							break;
						case "local":
							$tdList.eq(2).html(I18n.t("admin_local.doesnt_exists_in_central_database") + "<br/>" + node.data.id);
							break;
						default:
					}
					if (node.data.linked_product) {
						$tdList.eq(7).text(node.data.linked_product);
					}

					const grossWeight = instance.parseNumeric(node.data.grossWeight);
					const tareWeight = instance.parseNumeric(node.data.tareWeight);
					const hasImage = hasValue(node.data.image);
					const hasBarcode = !instance.isBadBarcodeValue(node.data);
					const hasName = hasValue(node.data.name);
					const quantity = instance.parseNumeric(node.data.quantity);
					const hasValidQuantity = hasValue(node.data.quantity) && Number.isFinite(quantity) && quantity > 0;
					const hasValidGrossWeight = hasValue(node.data.grossWeight) && Number.isFinite(grossWeight) && grossWeight >= 0;
					const hasValidTareWeight = hasValue(node.data.tareWeight) && Number.isFinite(tareWeight) && tareWeight >= 0;
					const invalidWeightRelation = hasValidGrossWeight && hasValidTareWeight && grossWeight <= tareWeight;
					const densityValidation = instance.getDensityValidation(node.data);
					const invalidDensity = densityValidation.outOfBounds;

					if (!hasImage) {
						addBadMarkBeforeImage(1);
					}

					if (!hasBarcode) {
						addBadMark(2);
					}

					if (!hasName) {
						addBadMark(3);
					}
					if (!hasValidQuantity || invalidDensity) {
						addBadMark(4);
					}
					if (!hasValidGrossWeight || invalidWeightRelation || invalidDensity) {
						addBadMark(5);
					}
					if (!hasValidTareWeight || invalidWeightRelation || invalidDensity) {
						addBadMark(6);
					}

					if (instance.isBadEntry(node.data)) {
						$(node.tr).addClass("itemBadEntry");
					} else {
						$(node.tr).removeClass("itemBadEntry");
					}
				},

			});
		} else {
			this.barcodes.reload(data);
			$('#edit').prop('disabled', 'true');
			$('#delete').prop('disabled', 'true');
		}
	}

	updateHooks = () => {
		const instance = this;
		$('div#editBarcode').on('show.bs.modal', function (event) {
			var modal = $(this)

			instance.modalOpen = modal;
			$("body").off("paste");
			$("body").on("paste", instance.paste);

			var button = $(event.relatedTarget) // Button that triggered the modal
			var recipient = button.data('whatever') // Extract info from data-*
			// attributes

			// Pre-loaded data from mobile barcode scan of existing record
			const preloaded = instance._editBarcodeData;
			if (preloaded) {
				instance._editBarcodeData = null;
				var data = preloaded;
				modal.find('input#id').val(data.id);
				modal.find('input#id').prop('readonly', true);
				modal.find('input#name').val(data.name);
				modal.find('input#quantity').val(data.quantity);
				modal.find('input#tare-weight').val(data.tareWeight || "");
				modal.find('input#gross-weight').val(data.grossWeight || "");
				if (data.image && data.image !== "") {
					const rawImageUrl = auth.server + "/" + auth.war + "/tableService/" + localStorage.restaurantSelected + "/getImage/" + data.image + "?timestamp=" + Date.now() + "&instance=" + localStorage.instance;
					modal.find("#smallImage").attr("src", getResizedImageUrl(rawImageUrl));
					modal.find("#smallImageDiv").removeClass("hidden");
				} else {
					modal.find("#smallImage").attr("src", "");
				}
				if (data.menuItem && data.menuItem.id) {
					modal.find('select.product').select2().val(data.menuItem.id);
					modal.find('select.product').trigger('change');
				} else {
					modal.find('select.product').select2().val(null);
					modal.find('select.product').trigger('change');
				}
			} else if (recipient === 'edit') {
				var data = instance.barcodes.getActiveNode().data;
				modal.find('input#id').val(data.id);
				modal.find('input#id').prop('readonly', true);
				modal.find('input#name').val(data.name);
				modal.find('input#quantity').val(data.quantity);
				modal.find('input#tare-weight').val(data.tareWeight);
				modal.find('input#gross-weight').val(data.grossWeight);
				if (data.image && data.image !== "") {
					const rawImageUrl = auth.server + "/" + auth.war + "/tableService/" + localStorage.restaurantSelected + "/getImage/" + data.image + "?timestamp=" + Date.now() + "&instance=" + localStorage.instance;
					modal.find("#smallImage").attr("src", getResizedImageUrl(rawImageUrl));
					$(modal.find("#smallImageDiv")).removeClass("hidden");
				} else {
					modal.find("#smallImage").attr("src", "");
					// $(modal.find('#smallImageDiv')).addClass('hidden');
				}
				modal.find('input#gross-weight').val(data.grossWeight);
				if (data.menuItem && data.menuItem.id) {
					modal.find('select.product').select2().val(data.menuItem.id);
					modal.find('select.product').trigger('change');
				} else {
					modal.find('select.product').select2().val(null);
					modal.find('select.product').trigger('change');
				}

			} else {
				modal.find('input#id').val("");
				modal.find('input#id').prop('readonly', false);
				modal.find('input#name').val("");
				modal.find('input#quantity').val("");
				modal.find('input#tare-weight').val("");
				modal.find('input#gross-weight').val("");
				modal.find("#smallImage").attr("src", "");
				modal.find('select.product').select2().val(null);
				modal.find('select.product').trigger('change');
			}
		})

		$('div#editBarcode').on('hide.bs.modal', function (event) {
			var modal = $(this);
			modal.find("#smallImage").attr("src", "");
		});

		const applyFilter = (event) => {
			this.filter[event.currentTarget.id] = event.currentTarget.value;
			this.barcodes.filterNodes(this.filterNodes, true);
		};

		$("#barcodes_select_all").on("change", (event) => {
			if (!this.barcodes) {
				return;
			}
			const checked = $(event.currentTarget).is(":checked");
			this.barcodes.selectAll(checked);
		});

		$("tr th input").on("keyup", applyFilter);
		$("#central_database_status").on("change", applyFilter);
		$("#entry_quality_status").on("change", applyFilter);

		// On iOS/Android: intercept the "Add" and "Edit" buttons to use the new calibration dialog.
		if (typeof device !== 'undefined' && auth.device.platform !== 'browser') {
			$('#add').on('click', (event) => {
				event.stopPropagation();
				scanbarcode().done(barcode => {
					// 1. Already in local DB → open pre-populated dialog
					const localRecord = this.localData && this.localData.find(b => String(b.id) === String(barcode));
					if (localRecord) {
						createAndLinkNewBarcode(barcode, () => this.loadBarcodes(), () => { }, {
							skipActualMeasure: true,
							existingRecord: localRecord
						});
						return;
					}

					// 2. Not local → check global DB
					getGlobal('adminService/2/getBarcode/' + barcode, undefined, undefined, false, true).done(globalEntry => {
						if (globalEntry && globalEntry.id) {
							// Found in global — import it (without image for now) then open pre-populated dialog
							const importData = {
								id: String(globalEntry.id),
								name: globalEntry.name,
								quantity: globalEntry.quantity,
								tareWeight: globalEntry.tareWeight || null,
								grossWeight: globalEntry.grossWeight || null,
							};
							// Fetch image if available
							const doImport = (imgSrc) => {
								if (imgSrc) importData.imageSrc = imgSrc;
								post('adminService/' + localStorage.restaurantSelected + '/addBarcode', importData).done(() => {
									getBarcode(String(globalEntry.id), barcodeEntry => {
										this.localData = this.localData ? [...this.localData, barcodeEntry] : [barcodeEntry];
										createAndLinkNewBarcode(barcode, () => this.loadBarcodes(), () => { }, {
											skipActualMeasure: true,
											existingRecord: barcodeEntry
										});
									}, () => {
										auth.ajaxError = false;
										this.loadBarcodes();
									});
								}).fail(() => {
									auth.ajaxError = false;
								});
							};
							if (globalEntry.image) {
								getString(auth.globalserver + '/' + auth.war + '/adminService/2/getRawImage/' + globalEntry.image).done(imgSrc => {
									doImport(imgSrc);
								}).fail(() => {
									auth.ajaxError = false;
									doImport(null);
								});
							} else {
								doImport(null);
							}
						} else {
							// 3. Not in global → create new
							createAndLinkNewBarcode(barcode, () => this.loadBarcodes(), () => { }, { skipActualMeasure: true });
						}
					}).fail(() => {
						auth.ajaxError = false;
						// Global lookup failed → fall through to create new
						createAndLinkNewBarcode(barcode, () => this.loadBarcodes(), () => { }, { skipActualMeasure: true });
					});
				});
			});

			$('#edit').on('click', (event) => {
				event.stopPropagation();
				const activeNode = this.barcodes && this.barcodes.getActiveNode();
				if (!activeNode) return;
				const data = activeNode.data;
				createAndLinkNewBarcode(data.id, () => this.loadBarcodes(), () => { }, {
					skipActualMeasure: true,
					existingRecord: data
				});
			});
		}

	}

	getBarcodes(handler, restaurantId) {
		get("adminService/" + (typeof restaurantId === "undefined" ? localStorage.restaurantSelected : restaurantId) + "/getBarcodes", localStorage.restaurantSelected).done(data => {
			if (data === null) {
				console.log("Failed to get barcodes!");
			} else {
				this.localData = data;
				handler([...data]);
			}
		});
	}

	saveBarcode = () => {
		var modal = $('div#editBarcode');
		var id = modal.find('input#id').val();
		var name = modal.find('#name').val();
		var quantity = modal.find('#quantity').val();
		var tareWeight = modal.find('input#tare-weight').val();
		if (!tareWeight)
			tareWeight = null;
		var grossWeight = modal.find('input#gross-weight').val();
		if (!grossWeight)
			grossWeight = null;
		var sm = $(modal.find("img#smallImage"));

		var menuItem = modal.find('select.product').select2().val();
		if ($.data(sm.get(0), "rcrop")) {
			this.crop(sm.get(0));
		}
		modal.find('input').removeClass('highlight-3');
		if (!id) {
			setTimeout(() => {
				modal.find('#id').addClass('highlight-3');
			}, 10)
			return;
		}
		if (!quantity) {
			setTimeout(() => {
				modal.find('#quantity').addClass('highlight-3');
			}, 10)
			return;
		}
		const parsedTareWeight = this.parseNumeric(tareWeight);
		const parsedGrossWeight = this.parseNumeric(grossWeight);
		if ((Number.isFinite(parsedTareWeight) && parsedTareWeight < 0) || (Number.isFinite(parsedGrossWeight) && parsedGrossWeight < 0)) {
			setTimeout(() => {
				if (Number.isFinite(parsedTareWeight) && parsedTareWeight < 0) {
					modal.find('#tare-weight').addClass('highlight-3');
				}
				if (Number.isFinite(parsedGrossWeight) && parsedGrossWeight < 0) {
					modal.find('#gross-weight').addClass('highlight-3');
				}
			}, 10);
			return;
		}
		var image = $(modal.find("#smallImage")).attr("src");
		if (image === "") image = null;
		if (menuItem === "null")
			menuItem = null;
		var type;
		if (menuItem) {
			type = getMenuItem(menuItem).entityType.toLowerCase();
		}
		if (modal.find('input#id').prop('readonly')) {
			this.modifyBarcode({ id: id, name: name, quantity: quantity, tareWeight: tareWeight, grossWeight: grossWeight, imageSrc: image, menuItem: menuItem ? { id: menuItem, type: type } : null }, this.loadBarcodes);
		} else {
			this.addBarcode({ id: id, name: name, quantity: quantity, tareWeight: tareWeight, grossWeight: grossWeight, imageSrc: image, menuItem: menuItem ? { id: menuItem, type: type } : null }, this.loadBarcodes);
		}
		modal.modal('hide');
	}

	deleteBarcode = () => {
		var data = this.barcodes.getActiveNode().data;
		const instance = this;
		confirmDialog(I18n.t('local.confirmation'), String.format(I18n.t('admin_local.are_you_sure_you_want_to_delete'), data.name)).done(function () {
			get("adminService/" + localStorage.restaurantSelected + "/deleteBarcode/" + data.id).done(function (data) {
				resultHandler(data, instance.loadBarcodes);
			});
		});

	}

	modifyBarcode(data, handler, errorHandler) {
		post("adminService/" + localStorage.restaurantSelected + "/modifyBarcode", data).done(function (data) {
			resultHandler(data, handler, errorHandler);
		});
	}

	addBarcode(data, handler, errorHandler) {
		post("adminService/" + localStorage.restaurantSelected + "/addBarcode", data).done(function (data) {
			resultHandler(data, handler, errorHandler);
		});
	}

	capturePhotoWithData(a, b) {
		capturePhotoWithData(a, b)
	}

	crop(a) {
		crop($(a));
	}

	phoneScanBarcode = () => {
		scanbarcode().done(barcode => {
			$('#editBarcode input#id').val(barcode)
		})
	}

	scaleMeasure = (t) => {
		scaleMeasure(localStorage.selected_scale).done(amount => {
			$(t).prev('input').val(amount)
		});
	}

	setSelectedScale(scale) {
		localStorage.selected_scale = scale;
		$('#editBarcode #selectedScale').html(scale);
		$('#bcSelectedScale').html(scale);
	}

	modalOpen = null;
	paste = (event) => {
		console.log("paste");
		if (this.modalOpen == null) return;
		const modal = this.modalOpen;
		var items = (event.clipboardData || event.originalEvent.clipboardData).items;
		for (let index in items) {
			var item = items[index];
			if (item.kind === "file") {
				var blob = item.getAsFile();
				var reader = new FileReader();
				reader.onload = function (event) {
					$(modal.find("#smallImageDiv")).removeClass("hidden");
					onPhotoDataSuccess(event.target.result, $(modal.find("#smallImageDiv img")));
				}; // data url!
				reader.readAsDataURL(blob);
			}
		}
	}

	calculate = type => {
		var modal = $('div#editBarcode');
		var quantity = Number(modal.find('#quantity').val());
		switch (type) {
			case "gross":
				var tareWeight = Number(modal.find('input#tare-weight').val());
				if (tareWeight > 0 && quantity > 0) {
					modal.find('input#gross-weight').val(Math.round(tareWeight * 100 + quantity) / 100);
				}
				break;
			case "tare":
				var grossWeight = Number(modal.find('input#gross-weight').val());
				if (grossWeight > 0 && quantity > 0) {
					modal.find('input#tare-weight').val(Math.round(grossWeight * 100 - quantity) / 100);
				}
				break;
			default:
		}
	}

	parseNumeric = (value) => {
		if (value === undefined || value === null) {
			return NaN;
		}
		if (typeof value === "number") {
			return Number.isFinite(value) ? value : NaN;
		}
		const normalized = ("" + value).replace(",", ".").trim();
		const parsed = Number(normalized);
		return Number.isFinite(parsed) ? parsed : NaN;
	}

	estimateExpectedContentWeightKg = (quantityValue) => {
		const quantity = this.parseNumeric(quantityValue);
		if (!Number.isFinite(quantity) || quantity <= 0) {
			return null;
		}

		// Heuristic unit conversion:
		// - <=15: liters (e.g. 0.5, 1, 1.5)
		// - 15..300: centiliters (e.g. 33, 50, 75, 100, 150)
		// - >300: milliliters (e.g. 500, 750, 1000)
		if (quantity <= 15) {
			return quantity;
		}
		if (quantity <= 300) {
			return quantity / 100;
		}
		return quantity / 1000;
	}

	getDensityValidation = (barcode) => {
		const grossWeight = this.parseNumeric(barcode && barcode.grossWeight);
		const tareWeight = this.parseNumeric(barcode && barcode.tareWeight);
		const expectedVolumeLiters = this.estimateExpectedContentWeightKg(barcode && barcode.quantity);

		if (!Number.isFinite(grossWeight) || !Number.isFinite(tareWeight) || !Number.isFinite(expectedVolumeLiters) || expectedVolumeLiters <= 0) {
			return { hasDensity: false, outOfBounds: false, densityKgPerL: null };
		}

		if (grossWeight < 0 || tareWeight < 0) {
			return { hasDensity: false, outOfBounds: false, densityKgPerL: null };
		}

		const netWeightKg = grossWeight - tareWeight;
		if (!(netWeightKg > 0)) {
			return { hasDensity: false, outOfBounds: false, densityKgPerL: null };
		}

		const densityKgPerL = netWeightKg / expectedVolumeLiters;
		const outOfBounds = densityKgPerL < LIQUID_MIN_DENSITY_KG_PER_L || densityKgPerL > LIQUID_MAX_DENSITY_KG_PER_L;

		return { hasDensity: true, outOfBounds, densityKgPerL };
	}

	getWeightQuantityConsistencyScore = (barcode) => {
		const grossWeight = this.parseNumeric(barcode && barcode.grossWeight);
		const tareWeight = this.parseNumeric(barcode && barcode.tareWeight);
		const densityValidation = this.getDensityValidation(barcode);

		if (!Number.isFinite(grossWeight) || !Number.isFinite(tareWeight)) {
			return 0;
		}

		const netWeight = grossWeight - tareWeight;
		if (!(netWeight > 0)) {
			return -4;
		}

		if (!densityValidation.hasDensity) {
			return 0;
		}

		if (densityValidation.outOfBounds) {
			return -6;
		}

		const density = densityValidation.densityKgPerL;
		if (density >= 0.95 && density <= 1.05) return 4;
		if (density >= 0.85 && density <= 1.2) return 2;
		if (density >= LIQUID_MIN_DENSITY_KG_PER_L && density <= LIQUID_MAX_DENSITY_KG_PER_L) return 1;

		return 0;
	}

	getBarcodeQualityScore = (barcode) => {
		if (!barcode) {
			return 0;
		}
		const quantity = this.parseNumeric(barcode.quantity);
		const grossWeight = this.parseNumeric(barcode.grossWeight);
		const tareWeight = this.parseNumeric(barcode.tareWeight);
		let score = 0;

		if (barcode.name && ("" + barcode.name).trim() !== "") score += 1;
		if (barcode.image && ("" + barcode.image).trim() !== "") score += 1;
		if (Number.isFinite(quantity) && quantity > 0) score += 1;
		if (Number.isFinite(grossWeight)) score += 1;
		if (Number.isFinite(tareWeight)) score += 1;
		if (Number.isFinite(grossWeight) && Number.isFinite(tareWeight) && grossWeight > tareWeight) score += 1;
		if (barcode.menuItem && barcode.menuItem.id) score += 1;
		score += this.getWeightQuantityConsistencyScore(barcode);

		return score;
	}

	choosePreferredSyncSource = (localBarcode, globalBarcode) => {
		const localScore = this.getBarcodeQualityScore(localBarcode);
		const globalScore = this.getBarcodeQualityScore(globalBarcode);
		const preferred = localScore >= globalScore ? "local" : "global";
		return { preferred, localScore, globalScore };
	}

	askConflictResolution = (localBarcode, globalBarcode) => {
		const deferred = new $.Deferred();
		const decision = this.choosePreferredSyncSource(localBarcode, globalBarcode);
		const preferredLabel = decision.preferred === "local" ? I18n.t("admin_local.local_value") : I18n.t("admin_local.global_value");
		const alternativeLabel = decision.preferred === "local" ? I18n.t("admin_local.global_value") : I18n.t("admin_local.local_value");
		const message =
			I18n.t("admin_local.exists_in_central_database") + " (" + (localBarcode && localBarcode.id ? localBarcode.id : "") + ")\n\n" +
			I18n.t("admin_local.local_value") + ": " + decision.localScore + "\n" +
			I18n.t("admin_local.global_value") + ": " + decision.globalScore + "\n\n" +
			"Hint: " + preferredLabel + " seems more accurate.\n" +
			"OK = " + preferredLabel + ", Cancel = " + alternativeLabel;

		confirmDialog(I18n.t('local.confirmation'), message)
			.done(() => deferred.resolve(decision.preferred))
			.fail(() => deferred.resolve(decision.preferred === "local" ? "global" : "local"));

		return deferred.promise();
	}

	pushGlobalToLocal = (globalBarcode, next) => {
		if (!globalBarcode) {
			next();
			return;
		}
		const payload = { ...globalBarcode };
		delete payload.status;
		if (payload.image)
			getString(auth.globalserver + "/" + auth.war + "/adminService/2/getRawImage/" + payload.image).done(image => {
				payload.imageSrc = image;
				post("adminService/" + localStorage.restaurantSelected + "/modifyBarcode", payload).done(() => {
					next();
				});
			})
		else
			post("adminService/" + localStorage.restaurantSelected + "/modifyBarcode", payload).done(() => {
				next();
			});
	}

	pushLocalToGlobal = (localBarcode, next) => {
		const payload = { ...localBarcode };
		delete payload.extraClasses;
		delete payload.folder;
		delete payload.status;
		delete payload.global;
		delete payload.linked_product;
		if (payload.image)
			getString("adminService/" + localStorage.restaurantSelected + "/getRawImage/" + payload.image).done(image => {
				payload.imageSrc = image;
				post(auth.globalserver + "/" + auth.war + "/adminService/2/modifyBarcode", payload).done(() => {
					next();
				});
			})
		else
			post(auth.globalserver + "/" + auth.war + "/adminService/2/modifyBarcode", payload).done(() => {
				next();
			});
	}

	pushGlobalToLocalPromise = (globalBarcode) => {
		const deferred = new $.Deferred();
		this.pushGlobalToLocal(globalBarcode, () => deferred.resolve());
		return deferred.promise();
	}

	buildCanonicalSyncPayload = (barcode) => {
		return {
			id: barcode && barcode.id,
			name: barcode && barcode.name,
			quantity: barcode && barcode.quantity,
			tareWeight: barcode && barcode.tareWeight,
			grossWeight: barcode && barcode.grossWeight,
		};
	}

	modifyLocalBarcodePromise = (payload, imageSrc = null) => {
		const deferred = new $.Deferred();
		const requestPayload = { ...payload };
		if (imageSrc) {
			requestPayload.imageSrc = imageSrc;
		}
		post("adminService/" + localStorage.restaurantSelected + "/modifyBarcode", requestPayload).done(() => deferred.resolve());
		return deferred.promise();
	}

	modifyGlobalBarcodePromise = (payload, imageSrc = null) => {
		const deferred = new $.Deferred();
		const requestPayload = { ...payload };
		if (imageSrc) {
			requestPayload.imageSrc = imageSrc;
		}
		post(auth.globalserver + "/" + auth.war + "/adminService/2/modifyBarcode", requestPayload).done(() => deferred.resolve());
		return deferred.promise();
	}

	getLocalRawImagePromise = (imageId) => {
		const deferred = new $.Deferred();
		if (!imageId) {
			deferred.resolve(null);
			return deferred.promise();
		}
		getString("adminService/" + localStorage.restaurantSelected + "/getRawImage/" + imageId)
			.done(imageSrc => deferred.resolve(imageSrc))
			.fail(() => deferred.resolve(null));
		return deferred.promise();
	}

	getGlobalRawImagePromise = (imageId) => {
		const deferred = new $.Deferred();
		if (!imageId) {
			deferred.resolve(null);
			return deferred.promise();
		}
		getString(auth.globalserver + "/" + auth.war + "/adminService/2/getRawImage/" + imageId)
			.done(imageSrc => deferred.resolve(imageSrc))
			.fail(() => deferred.resolve(null));
		return deferred.promise();
	}

	normalizeImagePayload = (imagePayload) => {
		if (!imagePayload) {
			return "";
		}
		const payload = ("" + imagePayload).trim();
		if (payload.startsWith("data:")) {
			const commaIndex = payload.indexOf(",");
			if (commaIndex >= 0) {
				return payload.substring(commaIndex + 1).trim();
			}
		}
		return payload;
	}

	areImagesIdenticalPromise = (localBarcode, globalBarcode) => {
		const deferred = new $.Deferred();
		const localHasImage = !!(localBarcode && localBarcode.image);
		const globalHasImage = !!(globalBarcode && globalBarcode.image);

		if (!localHasImage || !globalHasImage) {
			deferred.resolve(false);
			return deferred.promise();
		}

		this.getLocalRawImagePromise(localBarcode.image).done(localRaw => {
			this.getGlobalRawImagePromise(globalBarcode.image).done(globalRaw => {
				const normalizedLocal = this.normalizeImagePayload(localRaw);
				const normalizedGlobal = this.normalizeImagePayload(globalRaw);
				deferred.resolve(normalizedLocal !== "" && normalizedLocal === normalizedGlobal);
			});
		});

		return deferred.promise();
	}

	getSingleSidedImageSrcPromise = (localBarcode, globalBarcode) => {
		const localHasImage = !!(localBarcode && localBarcode.image);
		const globalHasImage = !!(globalBarcode && globalBarcode.image);
		if (localHasImage && !globalHasImage) {
			return this.getLocalRawImagePromise(localBarcode.image);
		}
		if (!localHasImage && globalHasImage) {
			return this.getGlobalRawImagePromise(globalBarcode.image);
		}
		const deferred = new $.Deferred();
		deferred.resolve(null);
		return deferred.promise();
	}

	askImageSourcePreference = (localBarcode, globalBarcode, preferredDataSource) => {
		const deferred = new $.Deferred();
		const localHasImage = !!(localBarcode && localBarcode.image);
		const globalHasImage = !!(globalBarcode && globalBarcode.image);

		if (!localHasImage && !globalHasImage) {
			deferred.resolve(null);
			return deferred.promise();
		}
		if (localHasImage && !globalHasImage) {
			deferred.resolve("local");
			return deferred.promise();
		}
		if (!localHasImage && globalHasImage) {
			deferred.resolve("global");
			return deferred.promise();
		}

		this.areImagesIdenticalPromise(localBarcode, globalBarcode).done(identicalImages => {
			if (identicalImages) {
				deferred.resolve(preferredDataSource);
				return;
			}

			const dialogId = "barcodeSyncImageChoiceDialog";
			$("#" + dialogId).remove();

			const preferredLabel = preferredDataSource === "local" ? I18n.t("admin_local.local_value") : I18n.t("admin_local.global_value");
			const localImageUrl = getResizedImageUrl(
				auth.server + "/" + auth.war + "/tableService/" + localStorage.restaurantSelected + "/getImage/" + localBarcode.image + "?instance=" + localStorage.instance + "&t=" + Date.now()
			);
			const globalImageUrl = getResizedImageUrl(
				auth.globalserver + "/" + auth.war + "/tableService/2/getImage/" + globalBarcode.image + "?instance=eatwithme&t=" + Date.now()
			);

			const $dlg = $(
				'<div id="' + dialogId + '" class="modal" tabindex="-1" style="display:block;background:rgba(0,0,0,.5);z-index:2200">' +
				'  <div class="modal-dialog" style="max-width:760px">' +
				'    <div class="modal-content">' +
				'      <div class="modal-header">' +
				'        <h5 class="modal-title">' + $('<div>').text(I18n.t('admin_local.barcode_sync_choose_image_title')).html() + '</h5>' +
				'      </div>' +
				'      <div class="modal-body">' +
				'        <p style="margin-bottom:.4rem">' + $('<div>').text(I18n.t('admin_local.barcode_sync_choose_image_message')).html() + '</p>' +
				'        <p style="margin-bottom:1rem;color:#666">' + $('<div>').text(I18n.t('admin_local.barcode_sync_hint_preferred') + ': ' + preferredLabel).html() + '</p>' +
				'        <p style="margin-bottom:1rem;color:#666">' + $('<div>').text(I18n.t('admin_local.barcode_sync_click_image_to_choose')).html() + '</p>' +
				'        <div style="display:flex;gap:1rem;align-items:flex-start;justify-content:space-between">' +
				'          <div id="barcodeSyncLocalImageCard" style="flex:1;text-align:center;border:1px solid #e5e5e5;border-radius:8px;padding:.8rem;cursor:pointer;transition:all .15s ease">' +
				'            <div style="font-weight:600;margin-bottom:.5rem">' + $('<div>').text(I18n.t('admin_local.barcode_sync_local_image')).html() + '</div>' +
				'            <img src="' + localImageUrl + '" style="max-height:220px;max-width:100%;object-fit:contain;border-radius:6px"/>' +
				'          </div>' +
				'          <div id="barcodeSyncGlobalImageCard" style="flex:1;text-align:center;border:1px solid #e5e5e5;border-radius:8px;padding:.8rem;cursor:pointer;transition:all .15s ease">' +
				'            <div style="font-weight:600;margin-bottom:.5rem">' + $('<div>').text(I18n.t('admin_local.barcode_sync_global_image')).html() + '</div>' +
				'            <img src="' + globalImageUrl + '" style="max-height:220px;max-width:100%;object-fit:contain;border-radius:6px"/>' +
				'          </div>' +
				'        </div>' +
				'      </div>' +
				'      <div class="modal-footer">' +
				'        <button id="barcodeSyncCancel" class="btn btn-secondary">' + $('<div>').text(I18n.t('admin_local.cancel')).html() + '</button>' +
				'      </div>' +
				'    </div>' +
				'  </div>' +
				'</div>'
			);

			$dlg.appendTo(document.body);
			const hoverIn = function () {
				$(this).css({ borderColor: "#007bff", boxShadow: "0 0 0 2px rgba(0,123,255,0.15)", background: "#f8fbff" });
			};
			const hoverOut = function () {
				$(this).css({ borderColor: "#e5e5e5", boxShadow: "none", background: "#fff" });
			};

			$dlg.find("#barcodeSyncLocalImageCard").on("mouseenter", hoverIn).on("mouseleave", hoverOut).on("click", () => {
				$dlg.remove();
				deferred.resolve("local");
			});
			$dlg.find("#barcodeSyncGlobalImageCard").on("mouseenter", hoverIn).on("mouseleave", hoverOut).on("click", () => {
				$dlg.remove();
				deferred.resolve("global");
			});
			$dlg.find("#barcodeSyncCancel").on("click", () => {
				$dlg.remove();
				deferred.resolve(null);
			});
		});

		return deferred.promise();
	}

	getChosenImageSrcPromise = (imageSource, localBarcode, globalBarcode) => {
		if (imageSource === "local") {
			return this.getLocalRawImagePromise(localBarcode && localBarcode.image);
		}
		if (imageSource === "global") {
			return this.getGlobalRawImagePromise(globalBarcode && globalBarcode.image);
		}
		const deferred = new $.Deferred();
		deferred.resolve(null);
		return deferred.promise();
	}

	synchronizeConflictByScorePromise = (localBarcode, globalBarcode) => {
		const deferred = new $.Deferred();
		const decision = this.choosePreferredSyncSource(localBarcode, globalBarcode);
		const canonical = this.buildCanonicalSyncPayload(decision.preferred === "local" ? localBarcode : globalBarcode);

		this.askImageSourcePreference(localBarcode, globalBarcode, decision.preferred).done(imageSource => {
			if (imageSource === null) {
				deferred.resolve();
				return;
			}
			this.getChosenImageSrcPromise(imageSource, localBarcode, globalBarcode).done(imageSrc => {
				this.modifyLocalBarcodePromise(canonical, imageSrc).done(() => {
					this.modifyGlobalBarcodePromise(canonical, imageSrc).done(() => {
						deferred.resolve();
					});
				});
			});
		});

		return deferred.promise();
	}

	synchronizeBarcodes = () => {
		const selectedIds = this.barcodes
			? new Set(this.barcodes.getSelectedNodes().map(n => String(n.data.id)))
			: new Set();
		return this.syncBarcodes({ autoResolveByScore: true, selectedIds });
	}

	syncBarcodes = (options = {}) => {
		const { autoResolveByScore = false, selectedIds = null } = options;
		const def = new $.Deferred()
		getGlobal("adminService/2/getBarcodes").done(globalBarcodes => {
			const map = new Map();
			const conflictCandidates = [];
			this.localData.forEach(barcode => {
				barcode.status = "local";
				map.set(barcode.id, barcode);
			});
			this.barcodesData = [...this.localData];
			globalBarcodes.forEach(barcode => {
				var m;
				if (m = map.get(barcode.id)) {
					//already exists
					m.status = "equal";
					delete m.syncHint;
					if (barcode.quantity != m.quantity) {
						m.status = "notequal";
					}
					if (barcode.grossWeight != m.grossWeight) {
						m.status = "notequal";
					}
					if (barcode.tareWeight != m.tareWeight) {
						m.status = "notequal";
					}
					map.get(barcode.id).global = barcode;
					if (m.status === "notequal") {
						m.syncHint = this.choosePreferredSyncSource(m, barcode);
						if (autoResolveByScore) {
							const isSelected = selectedIds instanceof Set && selectedIds.has(String(m.id));
							if (isSelected) {
								conflictCandidates.push({ local: { ...m }, global: { ...barcode } });
							}
						}
					}
				} else {
					//new
					barcode.status = "new";
					delete barcode.syncHint;
					this.barcodesData.push(barcode);
				}
			})
			this.processBarcodes(this.barcodesData);

			if (!autoResolveByScore || conflictCandidates.length === 0) {
				def.resolve(this.barcodesData);
				return;
			}

			let chain = $.Deferred().resolve().promise();
			conflictCandidates.forEach(candidate => {
				chain = chain.then(() => this.synchronizeConflictByScorePromise(candidate.local, candidate.global));
			});

			chain.then(() => {
				this.getBarcodes(() => {
					this.syncBarcodes({ autoResolveByScore: false }).done(updated => {
						def.resolve(updated);
					});
				});
			});
		});
		return def.promise();
	}
	downloadBarcodes = () => {
		this.syncBarcodes().done(barcodes => {
			if (this.barcodes.getSelectedNodes().length) {
				console.log(this.barcodes.getSelectedNodes().map(n => n.data));
				this.downloadOneBarcode(this.barcodes.getSelectedNodes().map(n => n.data).filter(barcode => barcode.name && barcode.quantity && barcode.tareWeight && barcode.grossWeight));
			} else {
				//this.downloadOneBarcode(barcodes.filter(barcode => barcode.status === "new" && this.selected(barcode)).filter(barcode => barcode.name && barcode.quantity && barcode.tareWeight && barcode.grossWeight));
			}
		});
	}

	uploadBarcodes = () => {
		this.syncBarcodes().done(barcodes => {
			this.uploadOneBarcode(barcodes.filter(barcode => barcode.status === "local").filter(barcode => barcode.name && barcode.quantity && barcode.tareWeight && barcode.grossWeight));
		});

	}
	uploadOneBarcode = (barcodes) => {
		const barcode = barcodes.shift();
		if (barcode) {
			delete barcode.extraClasses;
			delete barcode.folder;
			delete barcode.status;
			delete barcode.menuItem;
			if (barcode.image)
				getString("adminService/" + localStorage.restaurantSelected + "/getRawImage/" + barcode.image).done(image => {
					barcode.imageSrc = image;
					post(auth.globalserver + "/" + auth.war + "/adminService/2/addBarcode", barcode).done(data => {
						this.uploadOneBarcode(barcodes);
					});
				})
			else
				post(auth.globalserver + "/" + auth.war + "/adminService/2/addBarcode", barcode).done(data => {
					this.uploadOneBarcode(barcodes);
				});
		} else {
			this.getBarcodes(this.syncBarcodes);
		}

	}
	downloadOneBarcode = (barcodes) => {
		var barcode = barcodes.shift();
		if (barcode) {
			const originalBarcode = { ...barcode };
			barcode = { ...barcode };
			delete barcode.extraClasses;
			delete barcode.folder;
			delete barcode.menuItem;
			if (barcode.status === "notequal") {
				const localBarcode = { ...originalBarcode };
				const globalBarcode = barcode.global ? { ...barcode.global } : null;
				this.askConflictResolution(localBarcode, globalBarcode).done(source => {
					if (source === "local") {
						this.pushLocalToGlobal(localBarcode, () => this.downloadOneBarcode(barcodes));
					} else {
						this.pushGlobalToLocal(globalBarcode, () => this.downloadOneBarcode(barcodes));
					}
				});
			} else if (barcode.status === "equal") {
				barcode = barcode.global;
				this.pushGlobalToLocal(barcode, () => this.downloadOneBarcode(barcodes));
			} else {
				delete barcode.status;
				if (barcode.image)
					getString(auth.globalserver + "/" + auth.war + "/adminService/2/getRawImage/" + barcode.image).done(image => {
						barcode.imageSrc = image;
						post("adminService/" + localStorage.restaurantSelected + "/addBarcode", barcode).done(data => {
							this.downloadOneBarcode(barcodes);
						});
					})
				else
					post("adminService/" + localStorage.restaurantSelected + "/addBarcode", barcode).done(data => {
						this.downloadOneBarcode(barcodes);
					});
			}
		} else {
			this.barcodes.selectAll(false);
			this.getBarcodes(this.syncBarcodes);
		}

	}

}

export default BarcodesCode;

export const lookupAndLinkGlobalBarcode = (barcode, onLinked, onCancel) => {
	getGlobal("adminService/2/getBarcode/" + barcode, undefined, undefined, false, true).done(globalEntry => {
		if (!globalEntry || !globalEntry.id) {
			// Not in global DB — ask if user wants to create a new local entry
			confirmDialog(I18n.t('admin_local.barcode_not_in_global_db'), I18n.t('admin_local.create_new_barcode_question')).done(() => {
				createAndLinkNewBarcode(barcode, onLinked, onCancel);
			}).fail(() => {
				onCancel();
			});
			return;
		}
		const dialogId = 'linkBarcodeDialog';
		$('#' + dialogId).remove();
		const imageUrl = globalEntry.image
			? getResizedImageUrl(auth.globalserver + '/' + auth.war + '/tableService/2/getImage/' + globalEntry.image + '?timestamp=' + Date.now() + '&instance=' + localStorage.instance)
			: null;
		const imageHtml = imageUrl
			? '<img src="' + imageUrl + '" style="max-height:120px;max-width:120px;object-fit:contain;display:block;margin-bottom:.5rem"/>'
			: '';
		const infoRows = [
			globalEntry.quantity ? '<tr><td style="padding-right:1rem"><strong>' + $('<div>').text(I18n.t('admin_local.quantity')).html() + '</strong></td><td>' + globalEntry.quantity + '</td></tr>' : '',
			globalEntry.tareWeight ? '<tr><td style="padding-right:1rem"><strong>' + $('<div>').text(I18n.t('admin_local.tare_weight')).html() + '</strong></td><td>' + globalEntry.tareWeight + '</td></tr>' : '',
			globalEntry.grossWeight ? '<tr><td style="padding-right:1rem"><strong>' + $('<div>').text(I18n.t('admin_local.gross_weight')).html() + '</strong></td><td>' + globalEntry.grossWeight + '</td></tr>' : '',
		].join('');
		const $dlg = $(
			'<div id="' + dialogId + '" class="modal" tabindex="-1" style="display:block;background:rgba(0,0,0,.5);z-index:2100">' +
			'  <div class="modal-dialog">' +
			'    <div class="modal-content">' +
			'      <div class="modal-header"><h5 class="modal-title">' + $('<div>').text(I18n.t('admin_local.barcode_found_in_global_db')).html() + '</h5></div>' +
			'      <div class="modal-body">' +
			'        <div style="display:flex;gap:1rem;align-items:flex-start;margin-bottom:.75rem">' +
			imageHtml +
			'          <div>' +
			'            <p style="margin:0 0 .5rem"><strong>' + $('<div>').text(globalEntry.name || barcode).html() + '</strong></p>' +
			'            <table style="font-size:1.4rem">' + infoRows + '</table>' +
			'          </div>' +
			'        </div>' +
			'        <label>' + $('<div>').text(I18n.t('admin_local.select_local_product')).html() + '</label>' +
			'        <select id="linkBarcodeProductSelect" allowNull=true width="100%" style="width:100%" class="select2 product" allowClear=true data-placeholder="' + $('<div>').text(I18n.t('admin_local.select_local_product')).html() + '" entity="MenuItems" filter="isInventoryDisposalItem" root="activeMenuCategories" map=\'{"id":"id", "text":["shortName","name"], "children": "activeMenuItems"}\'>' +
			'        </select>' +
			'      </div>' +
			'      <div class="modal-footer">' +
			'        <button id="linkBarcodeSave" class="btn btn-primary">' + $('<div>').text(I18n.t('admin_local.link_and_continue')).html() + '</button>' +
			'        <button id="linkBarcodeSkip" class="btn btn-secondary">' + $('<div>').text(I18n.t('admin_local.skip')).html() + '</button>' +
			'      </div>' +
			'    </div>' +
			'  </div>' +
			'</div>'
		);
		$dlg.appendTo(document.body);
		admin.initializeSelect2($dlg.find('select.select2'));

		$dlg.find('#linkBarcodeSkip').on('click', () => {
			$dlg.remove();
			onCancel();
		});

		$dlg.find('#linkBarcodeSave').on('click', () => {
			const selectedId = $dlg.find('#linkBarcodeProductSelect').select2().val();

			$dlg.find('#linkBarcodeError').remove();
			if (!selectedId) {
				$('<div id="linkBarcodeError" class="alert alert-danger mt-2" style="padding:.4rem .75rem;font-size:1.4rem">')
					.text(I18n.t('admin_local.required_fields') + ': ' + I18n.t('admin_local.select_local_product'))
					.insertBefore($dlg.find('.modal-footer'));
				$dlg.find('#linkBarcodeProductSelect + span').addClass('highlight-3');
				return;
			}

			// Show spinner while measuring
			const waitId = 'waitScaleLinkDialog';
			$('#' + waitId).remove();
			const $wait = $(
				'<div id="' + waitId + '" class="modal" tabindex="-1" style="display:block;background:rgba(0,0,0,.5);z-index:2200">'
				+ '  <div class="modal-dialog" style="max-width:320px;margin:20vh auto">'
				+ '    <div class="modal-content text-center" style="padding:1.5rem">'
				+ '      <div class="spinner-border text-primary mb-3" role="status"><span class="sr-only">...</span></div>'
				+ '      <p class="mb-0">' + $('<div>').text(I18n.t('admin_local.measuring')).html() + '</p>'
				+ '    </div>'
				+ '  </div>'
				+ '</div>'
			).appendTo(document.body);

		scaleMeasure(localStorage.selected_scale).done(rawWeight => {
				$wait.remove();
				$dlg.remove();
				const menuItem = admin.getMenuItemAdmin(Number(selectedId), true) || getMenuItem(Number(selectedId));
				const menuItemType = menuItem ? menuItem.entityType.toLowerCase() : 'menuitem';
				const barcodeData = {
					id: String(globalEntry.id),
					name: globalEntry.name,
					quantity: globalEntry.quantity,
					tareWeight: globalEntry.tareWeight || null,
					grossWeight: globalEntry.grossWeight || null,
					menuItem: { id: Number(selectedId), type: menuItemType }
				};
				if (globalEntry.imageSrc) barcodeData.imageSrc = globalEntry.imageSrc;
				post("adminService/" + localStorage.restaurantSelected + "/addBarcode", barcodeData).done(() => {
					getBarcode(String(globalEntry.id), barcodeEntry => {
						onLinked(barcodeEntry, rawWeight);
					}, () => {
						auth.ajaxError = false;
						onLinked(null, rawWeight);
					});
				}).fail(() => {
					auth.ajaxError = false;
					onCancel();
				});
			}).fail(() => {
				$wait.remove();
				auth.ajaxError = false;
				onCancel();
			});
		});
	}).fail(() => {
		auth.ajaxError = false;
		confirmDialog(I18n.t('admin_local.barcode_not_in_global_db'), I18n.t('admin_local.create_new_barcode_question')).done(() => {
			createAndLinkNewBarcode(barcode, onLinked, onCancel);
		}).fail(() => {
			onCancel();
		});
	});
};


export const createAndLinkNewBarcode = (barcode, onLinked, onCancel, options = {}) => {
	const dialogId = 'createBarcodeDialog';
	$('#' + dialogId).remove();

	const existing = options.existingRecord || null;
	let measurements = existing && existing.grossWeight
		? { full: existing.grossWeight, empty: existing.tareWeight || null }
		: {}; // { full: kg|null, empty: kg|null }
	let cancelCallback = () => { $dlg.remove(); onCancel(); };

	// Build scale selection dropdown for header
	const scaleDropdownHtml = (() => {
		const scales = (auth.myStatus.restaurant_scales || []);
		if (!scales.length) return '';
		const items = scales.map(s =>
			'<a class="dropdown-item bcScaleItem" href="#" data-scale="' + $('<div>').text(s.name).html() + '" style="font-size:1.1rem">' + $('<div>').text(s.name).html() + '</a>'
		).join('') +
			'<a class="dropdown-item bcScaleItem" href="#" data-scale="Bluetooth" style="font-size:1.1rem">Bluetooth</a>';
		return '<div class="dropdown" style="margin-left:.75rem">' +
			'<button class="i_scale btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" style="font-size:1.05rem" id="bcSelectedScale">' +
			(localStorage.selected_scale || '') +
			'</button>' +
			'<div class="dropdown-menu dropdown-menu-right">' + items + '</div>' +
			'</div>';
	})();

	const $dlg = $(
		'<div id="' + dialogId + '" class="modal" tabindex="-1" style="display:block;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.5);z-index:2100;padding:0;overflow:hidden">' +
		'  <div class="modal-dialog" style="margin:0;max-width:100%;width:100%;height:100%">' +
		'    <div class="modal-content" style="font-size:1.15rem;border-radius:0;height:100%;display:flex;flex-direction:column">' +
		'      <div class="modal-header" style="padding:.75rem 1rem;flex-shrink:0;display:flex;align-items:center">' +
		'        <h4 class="modal-title" style="font-size:1.25rem;font-weight:600;margin:0;flex:1">' + $('<div>').text(I18n.t(existing ? 'admin_local.modify_barcode' : 'admin_local.create_new_barcode')).html() + '</h4>' +
		scaleDropdownHtml +
		'      </div>' +
		'      <div class="modal-body" style="flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:.75rem 1rem">' +
		// Spinner status row
		'        <div id="bcStatusRow" style="display:none;text-align:center;padding:.75rem 0">' +
		'          <div class="spinner-border text-primary mr-2" role="status" style="width:1.75rem;height:1.75rem;vertical-align:middle"><span class="sr-only">...</span></div>' +
		'          <span id="bcStatusMsg" style="font-size:1.15rem;vertical-align:middle"></span>' +
		'        </div>' +
		// Form section
		'        <div id="bcFormSection">' +
		(existing && !existing.menuItem ? '          <div class="alert alert-info" style="font-size:1.1rem">' + $('<div>').text(I18n.t('admin_local.no_product_linked')).html() + '</div>' : '') +
		'          <div class="alert alert-warning" style="font-size:1.1rem">' + $('<div>').text(I18n.t('admin_local.calibration_bottle_hint')).html() + '</div>' +
		'          <div class="form-group" style="margin-bottom:1rem">' +
		'            <label style="font-size:1.15rem;font-weight:500;margin-bottom:.35rem">' + $('<div>').text(I18n.t('admin_local.select_local_product')).html() + '</label>' +
		'            <select id="newBarcodeProduct" allowNull=true width="100%" style="width:100%;font-size:1.1rem" class="select2 product" allowClear=true' +
		'              entity="MenuItems" filter="isInventoryDisposalItem" root="activeMenuCategories"' +
		'              map=\'{"id":"id", "text":["shortName","name"], "children": "activeMenuItems"}\'>' +
		'            </select>' +
		'          </div>' +
		'          <div class="form-group" style="margin-bottom:1rem">' +
		'            <label style="font-size:1.15rem;font-weight:500;margin-bottom:.35rem">' + $('<div>').text(I18n.t('admin_local.barcode_name')).html() + '</label>' +
		'            <input id="newBarcodeName" type="text" class="form-control" style="font-size:1.15rem;height:2.8rem" />' +
		'          </div>' +
		'          <div class="form-group" style="margin-bottom:1rem">' +
		'            <label style="font-size:1.15rem;font-weight:500;margin-bottom:.35rem">' + $('<div>').text(I18n.t('admin_local.capacity_cl')).html() + '</label>' +
		'            <div style="display:flex;gap:.5rem;align-items:center;flex-wrap:wrap">' +
		'              <input id="newBarcodeCapacity" type="number" min="1" class="form-control" style="width:5.5rem;font-size:1.15rem;height:2.8rem" />' +
		'              <button type="button" class="btn btn-outline-secondary newBarcodeCapacityPreset" data-val="50" style="font-size:1.1rem;padding:.4rem .9rem">50</button>' +
		'              <button type="button" class="btn btn-outline-secondary newBarcodeCapacityPreset" data-val="70" style="font-size:1.1rem;padding:.4rem .9rem">70</button>' +
		'              <button type="button" class="btn btn-outline-secondary newBarcodeCapacityPreset" data-val="75" style="font-size:1.1rem;padding:.4rem .9rem">75</button>' +
		'              <button type="button" class="btn btn-outline-secondary newBarcodeCapacityPreset" data-val="100" style="font-size:1.1rem;padding:.4rem .9rem">100</button>' +
		'            </div>' +
		'          </div>' +
		'          <div class="form-group" style="margin-bottom:1rem' + (existing ? ';display:none' : '') + '">' +
		'            <label style="font-size:1.15rem;font-weight:500;margin-bottom:.35rem">' + $('<div>').text(I18n.t('admin_local.bottle_state')).html() + '</label>' +
		'            <div style="font-size:1.15rem;display:flex;gap:1.5rem">' +
		'              <label style="display:flex;align-items:center;gap:.4rem"><input type="radio" name="bottleState" value="full" style="width:1.2rem;height:1.2rem">' + $('<div>').text(I18n.t('admin_local.bottle_full')).html() + '</label>' +
		'              <label style="display:flex;align-items:center;gap:.4rem"><input type="radio" name="bottleState" value="empty" style="width:1.2rem;height:1.2rem">' + $('<div>').text(I18n.t('admin_local.bottle_empty')).html() + '</label>' +
		'            </div>' +
		'          </div>' +
		'          <div class="form-group" style="margin-bottom:1rem">' +
		'            <label style="font-size:1.15rem;font-weight:500;margin-bottom:.35rem">' + $('<div>').text(I18n.t('admin_local.photo')).html() + '</label>' +
		'            <div style="display:flex;align-items:center;gap:.75rem">' +
		'              <input id="newBarcodeCamera" type="file" accept="image" capture="environment" style="display:none"/>' +
		'              <button id="newBarcodePhotoBtn" type="button" class="btn btn-secondary icon icon-camera" style="font-size:1.1rem;padding:.5rem 1rem">' + $('<div>').text(I18n.t('admin_local.take_photo')).html() + '</button>' +
		'              <img id="newBarcodePreview" src="" style="max-height:80px;max-width:80px;object-fit:contain;display:none"/>' +
		'            </div>' +
		'          </div>' +
		'          <div id="bcFormError" class="alert alert-danger" style="display:none;font-size:1.1rem"></div>' +
		'        </div>' +
		// Calibration results section
		'        <div id="bcCalibSection" style="display:none;margin-top:.5rem">' +
		'          <h5 style="font-size:1.2rem;font-weight:600;margin-bottom:.5rem">' + $('<div>').text(I18n.t('admin_local.calibration_result')).html() + '</h5>' +
		'          <table id="bcCalibTable" class="table table-sm mb-0" style="font-size:1.1rem"></table>' +
		'        </div>' +
		// Actual bottle section (shown after save)
		'        <div id="bcActualSection" style="display:none;text-align:center;padding:1.5rem 0">' +
		'          <p style="font-size:1.2rem">' + $('<div>').text(I18n.t('admin_local.place_actual_bottle')).html() + '</p>' +
		'          <button id="bcMeasureActual" type="button" class="btn btn-primary" style="font-size:1.2rem;padding:.65rem 1.75rem">' + $('<div>').text(I18n.t('admin_local.measure_now')).html() + '</button>' +
		'        </div>' +
		'      </div>' +
		'      <div class="modal-footer" style="padding:.75rem 1rem;padding-bottom:calc(.75rem + env(safe-area-inset-bottom));flex-shrink:0">' +
		'        <button id="newBarcodeSave" type="button" class="btn btn-primary" style="font-size:1.15rem;padding:.65rem 1.5rem;flex:1">' + $('<div>').text(I18n.t(existing ? 'admin_local.save' : 'admin_local.measure_and_save')).html() + '</button>' +
		'        <button id="newBarcodeCancel" type="button" class="btn btn-secondary" style="font-size:1.15rem;padding:.65rem 1.5rem;flex:1">' + $('<div>').text(I18n.t('admin_local.cancel')).html() + '</button>' +
		'      </div>' +
		'    </div>' +
		'  </div>' +
		'</div>'
	);
	$dlg.appendTo(document.body);

	// Scale selection inside the dialog
	$dlg.on('click', '.bcScaleItem', function (e) {
		e.preventDefault();
		const scale = $(this).data('scale');
		localStorage.selected_scale = scale;
		$dlg.find('#bcSelectedScale').html(scale);
	});

	const select2Init = admin.initializeSelect2($dlg.find('select.select2'));

	const collectFormData = () => {
		const selectedId = $dlg.find('#newBarcodeProduct').select2('val');
		const menuItem = selectedId ? (admin.getMenuItemAdmin(Number(selectedId), true) || getMenuItem(Number(selectedId))) : null;
		return {
			selectedId,
			name: $dlg.find('#newBarcodeName').val().trim(),
			capacityCl: Number($dlg.find('#newBarcodeCapacity').val()),
			bottleState: $dlg.find('input[name="bottleState"]:checked').val(),
			imageSrc: $dlg.find('#newBarcodePreview').attr('src') || null,
			menuItemType: menuItem ? menuItem.entityType.toLowerCase() : 'menuitem'
		};
	};

	const setMeasuring = (msg) => {
		$dlg.find('#bcStatusMsg').text(msg);
		$dlg.find('#bcStatusRow').show();
		$dlg.find('button').prop('disabled', true);
		$dlg.find('input:not([type=file]), select').prop('disabled', true);
	};

	const clearMeasuring = () => {
		$dlg.find('#bcStatusRow').hide();
		$dlg.find('button').prop('disabled', false);
		$dlg.find('input:not([type=file]), select').prop('disabled', false);
	};

	const renderCalibResults = () => {
		const formData = collectFormData();
		const noMeasurements = measurements.full == null && measurements.empty == null;

		if (noMeasurements && !existing) {
			$dlg.find('#bcCalibSection').hide();
			return;
		}

		const liquidKg = formData.capacityCl / 100;
		let fullKg = measurements.full;
		let emptyKg = measurements.empty;
		if (!noMeasurements) {
			if (fullKg == null) fullKg = Math.round((emptyKg + liquidKg) * 1000) / 1000;
			if (emptyKg == null) emptyKg = Math.round((fullKg - liquidKg) * 1000) / 1000;
		}

		const makeRow = (state, kg, isMeasured) => {
			const labelKey = (isMeasured ? 'measured_' : 'estimated_') + state + '_bottle_weight';
			return '<tr>'
				+ '<td style="vertical-align:middle;font-size:1.1rem;padding:.5rem .4rem">' + $('<div>').text(I18n.t('admin_local.' + labelKey)).html() + '</td>'
				+ '<td style="vertical-align:middle;padding:.5rem .4rem">'
				+ '<input type="number" step="0.001" class="form-control calibWeightInput" data-state="' + state + '" value="' + (kg != null ? kg : '') + '" style="width:6rem;font-size:1.1rem;height:2.6rem;display:inline-block"/>'
				+ ' <span style="font-size:1rem" class="text-muted">kg</span>'
				+ '</td>'
				+ '<td style="vertical-align:middle;padding:.5rem .4rem"><button type="button" class="btn btn-outline-secondary calibRemeasure" data-state="' + state + '" style="font-size:1rem;padding:.4rem .75rem;white-space:nowrap">'
				+ $('<div>').text(I18n.t('admin_local.remeasure_' + state + '_bottle')).html() + '</button></td>'
				+ '</tr>';
		};

		$dlg.find('#bcCalibTable').html(
			makeRow('full', fullKg, measurements.full != null)
			+ makeRow('empty', emptyKg, measurements.empty != null)
		);
		$dlg.find('#bcCalibSection').show();
		if (!existing) $dlg.find('#newBarcodeSave').text(I18n.t('admin_local.approve_and_save'));
	};

	// Capacity change → reset measurements
	$dlg.find('#newBarcodeCapacity').on('input', () => {
		measurements = {};
		renderCalibResults();
	});
	$dlg.find('.newBarcodeCapacityPreset').on('click', function () {
		$dlg.find('#newBarcodeCapacity').val($(this).data('val'));
		measurements = {};
		renderCalibResults();
	});

	$dlg.find('#newBarcodeProduct').on('change', function () {
		const id = $(this).select2('val');
		if (id) {
			const item = admin.getMenuItemAdmin(Number(id), true) || getMenuItem(Number(id));
			if (item && !$dlg.find('#newBarcodeName').val()) {
				$dlg.find('#newBarcodeName').val(getLocale(item.name));
			}
		}
	});

	$dlg.find('#newBarcodePhotoBtn').on('click', () => {
		$dlg.find('#newBarcodeCamera').trigger('click');
	});
	$dlg.find('#newBarcodeCamera').on('change', function () {
		const file = this.files[0];
		if (!file) return;
		const reader = new FileReader();
		reader.onload = (e) => {
			$dlg.find('#newBarcodePreview').attr('src', e.target.result).show();
		};
		reader.readAsDataURL(file);
	});

	$dlg.find('#newBarcodeCancel').on('click', () => cancelCallback());

	// Pre-populate from existing record after all handlers are wired
	if (existing) {
		if (existing.name) $dlg.find('#newBarcodeName').val(existing.name);
		if (existing.quantity) $dlg.find('#newBarcodeCapacity').val(existing.quantity);
		if (existing.image) {
			const imgUrl = getResizedImageUrl(auth.server + '/' + auth.war + '/tableService/' + localStorage.restaurantSelected + '/getImage/' + existing.image + '?timestamp=' + Date.now() + '&instance=' + localStorage.instance);
			$dlg.find('#newBarcodePreview').attr('src', imgUrl).show();
		}
		// Always show calibration section for existing records
		renderCalibResults();
		// Set the product dropdown once select2 data is loaded
		select2Init.done(() => {
			if (existing.menuItem && existing.menuItem.id) {
				$dlg.find('#newBarcodeProduct').val(String(existing.menuItem.id)).trigger('change');
			}
		});
	}

	// Weight input manual edit (delegated — rendered dynamically)
	$dlg.on('change', '.calibWeightInput', function () {
		const state = $(this).data('state');
		const val = parseFloat($(this).val());
		if (!isNaN(val) && val > 0) {
			measurements[state] = Math.round(val * 1000) / 1000;
		}
	});

	// Re-measure button (delegated — rendered dynamically)
	$dlg.on('click', '.calibRemeasure', function () {
		const targetState = $(this).data('state');
		setMeasuring(I18n.t('admin_local.measuring_calibration'));
		scaleMeasure(localStorage.selected_scale).done(w => {
			measurements[targetState] = w;
			clearMeasuring();
			renderCalibResults();
		}).fail(() => {
			auth.ajaxError = false;
			clearMeasuring();
		});
	});

	$dlg.find('#newBarcodeSave').on('click', () => {
		const formData = collectFormData();
		const { selectedId, name, capacityCl, bottleState } = formData;

		$dlg.find('#bcFormError').hide();
		const errors = [];
		if (!selectedId) errors.push(I18n.t('admin_local.select_local_product'));
		if (!name) errors.push(I18n.t('admin_local.barcode_name'));
		if (!capacityCl || capacityCl <= 0) errors.push(I18n.t('admin_local.capacity_cl'));
		if (!bottleState && !existing && !(measurements.full != null || measurements.empty != null)) {
			errors.push(I18n.t('admin_local.bottle_state'));
		}
		if (errors.length) {
			$dlg.find('#bcFormError').text(I18n.t('admin_local.required_fields') + ': ' + errors.join(', ')).show();
			return;
		}

		const hasMeasurements = true; // always save directly, never trigger measurement on save

		if (hasMeasurements) {
			// Sync any manually edited weight inputs into measurements before saving
			$dlg.find('.calibWeightInput').each(function () {
				const state = $(this).data('state');
				const val = parseFloat($(this).val());
				measurements[state] = (!isNaN(val) && val > 0) ? Math.round(val * 1000) / 1000 : null;
			});
			// Derive missing weight from the other if possible
			const liquidKg = capacityCl / 100;
			let fullKg = measurements.full != null ? measurements.full
				: (measurements.empty != null ? Math.round((measurements.empty + liquidKg) * 1000) / 1000 : null);
			let emptyKg = measurements.empty != null ? measurements.empty
				: (measurements.full != null ? Math.round((measurements.full - liquidKg) * 1000) / 1000 : null);

			const barcodeData = {
				id: String(barcode),
				name,
				quantity: capacityCl,
				tareWeight: emptyKg,
				grossWeight: fullKg,
				menuItem: { id: Number(selectedId), type: formData.menuItemType }
			};
			if (formData.imageSrc && formData.imageSrc !== '') barcodeData.imageSrc = formData.imageSrc;

			const saveUrl = existing
				? 'adminService/' + localStorage.restaurantSelected + '/modifyBarcode'
				: 'adminService/' + localStorage.restaurantSelected + '/addBarcode';
			setMeasuring(I18n.t('admin_local.measuring') || 'Saving...');
			post(saveUrl, barcodeData).done(() => {
				getBarcode(String(barcode), barcodeEntry => {
					clearMeasuring();
					if (options.skipActualMeasure) {
						$dlg.remove();
						onLinked(barcodeEntry, null);
						return;
					}
					// Switch dialog to actual bottle phase
					cancelCallback = () => { $dlg.remove(); onLinked(barcodeEntry, null); };
					$dlg.find('#bcFormSection, #bcCalibSection').hide();
					$dlg.find('#newBarcodeSave').hide();
					$dlg.find('#bcActualSection').show();

					$dlg.find('#bcMeasureActual').on('click', () => {
						setMeasuring(I18n.t('admin_local.measuring_actual'));
						scaleMeasure(localStorage.selected_scale).done(actualWeight => {
							$dlg.remove();
							onLinked(barcodeEntry, actualWeight);
						}).fail(() => {
							auth.ajaxError = false;
							$dlg.remove();
							onLinked(barcodeEntry, null);
						});
					});
				}, () => {
					auth.ajaxError = false;
					$dlg.remove();
					onLinked(null, null);
				});
			}).fail(() => {
				auth.ajaxError = false;
				clearMeasuring();
			});
		} else {
			// Measure & Save — measure the calibration bottle first
			setMeasuring(I18n.t('admin_local.measuring_calibration'));
			scaleMeasure(localStorage.selected_scale).done(calibWeight => {
				measurements[bottleState] = calibWeight;
				clearMeasuring();
				renderCalibResults();
			}).fail(() => {
				auth.ajaxError = false;
				clearMeasuring();
			});
		}
	});
};
